"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../utils/fetch");
exports.default = {
    getPlaceStats: function () {
        return fetch_1.default("/stats/places", {
            method: "GET",
        });
    },
    getGeneralStats: function (stepBy, from, to) {
        return fetch_1.default("/stats/general", {
            method: "GET",
        }, {
            stepBy: stepBy,
            from: from ? from.toISOString() : undefined,
            to: to ? to.toISOString() : undefined,
        });
    },
};
//# sourceMappingURL=stats.js.map